import { Lift } from '@models/lift.model';
// @ts-ignore
import { Action } from "@ngrx/store";
import { Tray } from '@models/tray.model';
import { Slot } from '@models/slot.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Batch } from '@models/batch.model';
import { Plant } from '@models/plant.model';
import { PagedResponse } from "@models/response.model";
import { TrayType } from "@models/enums/tray-type.enum";
import { Line } from "@models/line.model";
import { LiftToolFilters } from '../models/lift-tool-filters.model';

// Get Lifts
export const LOAD_LIFTS = '[Lifts] Load Lifts';
export const LOAD_LIFTS_SUCCESS = '[Lifts] Load Lifts Success';
export const LOAD_LIFTS_FAILED = '[Lifts] Load Lifts Failure';


export class LoadLiftsAction implements Action {
    readonly type = LOAD_LIFTS;

    constructor(public config: any) {
    }
}

export class LoadLiftsSuccessAction implements Action {
    readonly type = LOAD_LIFTS_SUCCESS;

    constructor(public payload: PagedResponse<Lift>, public firstPage: boolean) {
    }
}

export class LoadLiftsFailedAction implements Action {
    readonly type = LOAD_LIFTS_FAILED;

    constructor(public payload: any) {
    }
}

// Get Lift
export const LOAD_LIFT = '[Lifts] Load Lift';
export const LOAD_LIFT_SUCCESS = '[Lifts] Load Lift Success';
export const LOAD_LIFT_FAILED = '[Lifts] Load Lift Failure';

export class LoadLiftAction implements Action {
    readonly type = LOAD_LIFT;

    constructor(public id: number, public filters: LiftToolFilters = {}) {
    }
}

export class LoadLiftSuccessAction implements Action {
    readonly type = LOAD_LIFT_SUCCESS;

    constructor(public payload: Lift) {
    }
}

export class LoadLiftFailedAction implements Action {
    readonly type = LOAD_LIFT_FAILED;

    constructor(public error: any) {
    }
}

// Add Lift
export const ADD_LIFT = '[Lifts] Add Lift';
export const ADD_LIFT_SUCCESS = '[Lifts] Add Lift Success';
export const ADD_LIFT_FAILED = '[Lifts] Add Lift Failure';

export class AddLiftAction implements Action {
    readonly type = ADD_LIFT;

    constructor(public payload: Lift) {
    }
}

export class AddLiftSuccessAction implements Action {
    readonly type = ADD_LIFT_SUCCESS;

    constructor(public payload: Lift) {
    }
}

export class AddLiftFailedAction implements Action {
    readonly type = ADD_LIFT_FAILED;

    constructor(public payload: any) {
    }
}


// Load Plants
export const LOAD_PLANTS = '[Lifts] Load Plants';
export const LOAD_PLANTS_SUCCESS = '[Lifts] Load Plants Success';
export const LOAD_PLANTS_FAILED = '[Lifts] Load Plants Failure';

export class LoadPlantsAction implements Action {
    readonly type = LOAD_PLANTS;

    constructor() {
    }
}

export class LoadPlantsSuccessAction implements Action {
    readonly type = LOAD_PLANTS_SUCCESS;

    constructor(public payload: Plant[]) {
    }
}

export class LoadPlantsFailedAction implements Action {
    readonly type = LOAD_PLANTS_FAILED;

    constructor(public error: any) {
    }
}

// Load Lines
export const LOAD_LINES = '[Lifts] Load Lines';
export const LOAD_LINES_SUCCESS = '[Lifts] Load Lines Success';
export const LOAD_LINES_FAILED = '[Lifts] Load Lines Failure';

export class LoadLinesAction implements Action {
    readonly type = LOAD_LINES;

    constructor() {
    }
}

export class LoadLinesSuccessAction implements Action {
    readonly type = LOAD_LINES_SUCCESS;

    constructor(public payload: Line[]) {
    }
}

export class LoadLinesFailedAction implements Action {
    readonly type = LOAD_LINES_FAILED;

    constructor(public error: any) {
    }
}

// Rename lift
export const RENAME_LIFT = '[Lifts] Rename Lift';
export const RENAME_LIFT_SUCCESS = '[Lifts] Rename Lift Success';
export const RENAME_LIFT_FAILED = '[Lifts] Rename Lift Failure';

export class RenameLiftAction implements Action {
    readonly type = RENAME_LIFT;

    constructor(public lift: Lift, public newName: string) {
    }
}

export class RenameLiftSuccessAction implements Action {
    readonly type = RENAME_LIFT_SUCCESS;

    constructor(public payload: Lift) {
    }
}

export class RenameLiftFailedAction implements Action {
    readonly type = RENAME_LIFT_FAILED;

    constructor(public payload: any) {
    }
}

// Delete lift
export const DELETE_LIFT = '[Lifts] Delete Lift';
export const DELETE_LIFT_SUCCESS = '[Lifts] Delete Lift Success';
export const DELETE_LIFT_FAILED = '[Lifts] Delete Lift Failure';

export class DeleteLiftAction implements Action {
    readonly type = DELETE_LIFT;

    constructor(public payload: Lift) {
    }
}

export class DeleteLiftSuccessAction implements Action {
    readonly type = DELETE_LIFT_SUCCESS;

    constructor(public payload: Lift) {
    }
}

export class DeleteLiftFailedAction implements Action {
    readonly type = DELETE_LIFT_FAILED;

    constructor(public payload: any) {
    }
}

// Add tray
export const ADD_TRAY = '[Lifts] Add Tray';
export const ADD_TRAY_SUCCESS = '[Lifts] Add Tray Success';
export const ADD_TRAY_FAILED = '[Lifts] Add Tray Failure';


export class AddTrayAction implements Action {
    readonly type = ADD_TRAY;

    constructor(public lift: Lift, public positions: number, public name: number, public trayType: TrayType) {
    }
}

export class AddTraySuccessAction implements Action {
    readonly type = ADD_TRAY_SUCCESS;

    constructor(public payload: Tray) {
    }
}

export class AddTrayFailedAction implements Action {
    readonly type = ADD_TRAY_FAILED;

    constructor(public payload: any) {
    }
}

// Delete tray
export const DELETE_TRAY = '[Lifts] Delete Tray';
export const DELETE_TRAY_SUCCESS = '[Lifts] Delete Tray Success';
export const DELETE_TRAY_FAILED = '[Lifts] Delete Tray Failure';


export class DeleteTrayAction implements Action {
    readonly type = DELETE_TRAY;

    constructor(public lift: Lift, public tray: Tray) {
    }
}

export class DeleteTraySuccessAction implements Action {
    readonly type = DELETE_TRAY_SUCCESS;

    constructor(public payload: Tray) {
    }
}

export class DeleteTrayFailedAction implements Action {
    readonly type = DELETE_TRAY_FAILED;

    constructor(public payload: any) {
    }
}

// Toggle tray state
export const TOGGLE_TRAY_STATE = '[Lifts] Toggle Tray State';
export const TOGGLE_TRAY_STATE_SUCCESS = '[Lifts] Toggle Tray State Success';
export const TOGGLE_TRAY_STATE_FAILED = '[Lifts] Toggle Tray State Failure';


export class ToggleTrayStateAction implements Action {
    readonly type = TOGGLE_TRAY_STATE;

    constructor(public lift: Lift, public tray: Tray) {
    }
}

export class ToggleTrayStateSuccessAction implements Action {
    readonly type = TOGGLE_TRAY_STATE_SUCCESS;

    constructor(public payload: Tray) {
    }
}

export class ToggleTrayStateFailedAction implements Action {
    readonly type = TOGGLE_TRAY_STATE_FAILED;

    constructor(public payload: any) {
    }
}

// Update tray
export const UPDATE_TRAY = '[Lifts] Update Tray ';
export const UPDATE_TRAY_SUCCESS = '[Lifts] Update State Success';
export const UPDATE_TRAY_FAILED = '[Lifts] Update State Failure';


export class UpdateTrayAction implements Action {
    readonly type = UPDATE_TRAY;

    constructor(public liftId: number, public tray: Tray) {
    }
}

export class UpdateTraySuccessAction implements Action {
    readonly type = UPDATE_TRAY_SUCCESS;

    constructor(public payload: Tray) {
    }
}

export class UpdateTrayFailedAction implements Action {
    readonly type = UPDATE_TRAY_FAILED;

    constructor(public payload: any) {
    }
}

// Load tray details
export const LOAD_TRAY_DETAILS = '[Lifts] Load Tray Details';
export const LOAD_TRAY_DETAILS_SUCCESS = '[Lifts] Load Tray Details Success';
export const LOAD_TRAY_DETAILS_FAILED = '[Lifts] Load Tray Details Failure';


export class LoadTrayDetailsAction implements Action {
    readonly type = LOAD_TRAY_DETAILS;

    constructor(public liftId: number, public trayId: number, public filters: LiftToolFilters = {}) {
    }
}

export class LoadTrayDetailsSuccessAction implements Action {
    readonly type = LOAD_TRAY_DETAILS_SUCCESS;

    constructor(public payload: Tray) {
    }
}

export class LoadTrayDetailsFailedAction implements Action {
    readonly type = LOAD_TRAY_DETAILS_FAILED;

    constructor(public payload: any) {
    }
}

// Load slot
export const LOAD_SLOT = '[Lifts] Load Slot';
export const LOAD_SLOT_SUCCESS = '[Lifts] Load Slot Success';
export const LOAD_SLOT_FAILED = '[Lifts] Load Slot Failure';


export class LoadSlotAction implements Action {
    readonly type = LOAD_SLOT;

    constructor(public liftId: number, public trayId: number, public slotId: number,
                public filters: LiftToolFilters = {}) {
    }
}

export class LoadSlotSuccessAction implements Action {
    readonly type = LOAD_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class LoadSlotFailedAction implements Action {
    readonly type = LOAD_SLOT_FAILED;

    constructor(public payload: any) {
    }
}


// Rename slot
export const RENAME_SLOT = '[Lifts] Rename Slot';
export const RENAME_SLOT_SUCCESS = '[Lifts] Rename Slot Success';
export const RENAME_SLOT_FAILED = '[Lifts] Rename Slot Failure';


export class RenameSlotAction implements Action {
    readonly type = RENAME_SLOT;

    constructor(public liftId: number, public trayId: number, public slot: Slot) {
    }
}

export class RenameSlotSuccessAction implements Action {
    readonly type = RENAME_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class RenameSlotFailedAction implements Action {
    readonly type = RENAME_SLOT_FAILED;

    constructor(public payload: any) {
    }
}


// Add slot
export const ADD_SLOT = '[Lifts] Add Slot';
export const ADD_SLOT_SUCCESS = '[Lifts] Add Slot Success';
export const ADD_SLOT_FAILED = '[Lifts] Add Slot Failed';


export class AddSlotAction implements Action {
    readonly type = ADD_SLOT;

    constructor(public liftId: number, public trayId: number, public slot: Slot) {
    }
}

export class AddSlotSuccessAction implements Action {
    readonly type = ADD_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class AddSlotFailedAction implements Action {
    readonly type = ADD_SLOT_FAILED;

    constructor(public payload: any) {
    }
}

// Duplicate slot
export const DUPLICATE_SLOT = '[Lifts] Duplicate Slot';
export const LOAD_DUPLICATED_SLOT = '[Lifts] Load Duplicated Slot';
export const LOAD_DUPLICATED_SLOT_SUCCESS = '[Lifts] Load Duplicated Slot Success';
export const DUPLICATE_SLOT_FAILED = '[Lifts] Duplicate Slot Failed';


export class DuplicateSlotAction implements Action {
    readonly type = DUPLICATE_SLOT;

    constructor(public liftId: number, public trayId: number, public id: number) {
    }
}

export class LoadDuplicatedSlotAction implements Action {
    readonly type = LOAD_DUPLICATED_SLOT;

    constructor(public liftId: number, public trayId: number, public id: number) {
    }
}

export class LoadDuplicatedSlotSuccessAction implements Action {
    readonly type = LOAD_DUPLICATED_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class DuplicateSlotFailedAction implements Action {
    readonly type = DUPLICATE_SLOT_FAILED;

    constructor(public payload: any) {
    }
}

// Copy slot
export const COPY_SLOT = '[Lifts] Copy Slot';
export const LOAD_COPIED_SLOT = '[Lifts] Load Copied Slot';
export const LOAD_COPIED_SLOT_SUCCESS = '[Lifts] Load Copied Slot Success';
export const COPY_SLOT_SUCCESS = '[Lifts] Copy Slot Success';
export const COPY_SLOT_FAILED = '[Lifts] Copy Slot Failed';


export class CopySlotAction implements Action {
    readonly type = COPY_SLOT;

    constructor(public prevLiftId: number, public prevTrayId: number, public liftId: number, public trayId: number, public id: number) {
    }
}

export class LoadCopiedSlotAction implements Action {
    readonly type = LOAD_COPIED_SLOT;

    constructor(public liftId: number, public trayId: number, public id: number) {
    }
}

export class LoadCopiedSlotSuccessAction implements Action {
    readonly type = LOAD_COPIED_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class CopySlotSuccessAction implements Action {
    readonly type = COPY_SLOT_SUCCESS;
}

export class CopySlotFailedAction implements Action {
    readonly type = COPY_SLOT_FAILED;

    constructor(public payload: any) {
    }
}


// DELETE slot
export const DELETE_SLOT = '[Lifts] Delete Slot';
export const DELETE_SLOT_SUCCESS = '[Lifts] Delete Slot Success';
export const DELETE_SLOT_FAILED = '[Lifts] Delete Slot Failure';


export class DeleteSlotAction implements Action {
    readonly type = DELETE_SLOT;

    constructor(public liftId: number, public trayId: number, public slotId: number) {
    }
}

export class DeleteSlotSuccessAction implements Action {
    readonly type = DELETE_SLOT_SUCCESS;

    constructor(public payload: Slot) {
    }
}

export class DeleteSlotFailedAction implements Action {
    readonly type = DELETE_SLOT_FAILED;

    constructor(public payload: any) {
    }
}


// Load All Tools
export const LOAD_ALL_TOOLS = '[Lifts] Load All Tools';
export const LOAD_ALL_TOOLS_BY_SLOT = '[Lifts] Load All Tools by Slot';
export const LOAD_ALL_TOOLS_SUCCESS = '[Lifts] Load All Tools Success';
export const LOAD_ALL_TOOLS_FAILED = '[Lifts] Load All Tools Failed';


export class LoadAllToolsAction implements Action {
    readonly type = LOAD_ALL_TOOLS;

    constructor(public config: TableConfig) {
    }
}

export class LoadAllToolsBySlotAction implements Action {
    readonly type = LOAD_ALL_TOOLS_BY_SLOT;

    constructor(public slot: Slot) {
    }
}

export class LoadAllToolsSuccessAction implements Action {
    readonly type = LOAD_ALL_TOOLS_SUCCESS;

    constructor(public payload: any) {
    }
}

export class LoadAllToolsFailedAction implements Action {
    readonly type = LOAD_ALL_TOOLS_FAILED;

    constructor(public payload: any) {
    }
}

// Load Batch action
export const LOAD_BATCH = '[Lifts] Load Batch by Slot';
export const LOAD_BATCH_SUCCESS = '[Lifts] Load Batch by Slot Success';
export const LOAD_BATCH_FAILED = '[Lifts] Load Batch by Slot Failure';


export class LoadBatchAction implements Action {
    readonly type = LOAD_BATCH;

    constructor(public batchId: number, public config: TableConfig) {
    }
}

export class LoadBatchSuccessAction implements Action {
    readonly type = LOAD_BATCH_SUCCESS;

    constructor(public batch: Batch) {

    }
}

export class LoadBatchFailedAction implements Action {
    readonly type = LOAD_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Copy Batch action
export const COPY_BATCH = '[Lifts] Copy Batch by Slot';
export const COPY_BATCH_SUCCESS = '[Lifts] Copy Batch by Slot Success';
export const COPY_BATCH_FAILED = '[Lifts] Copy Batch by Slot Failure';

export class CopyBatchAction implements Action {
    readonly type = COPY_BATCH;

    constructor(public slotId: number, public tools: any[], public name: string, public withStorage: boolean) {
    }
}

export class CopyBatchSuccessAction implements Action {
    readonly type = COPY_BATCH_SUCCESS;

    constructor(public batch: Batch) {

    }
}

export class CopyBatchFailedAction implements Action {
    readonly type = COPY_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Duplicate Batch action
export const DUPLICATE_BATCH = '[Lifts] Duplicate Batch by Slot';
export const DUPLICATE_BATCH_SUCCESS = '[Lifts] Duplicate Batch by Slot Success';
export const DUPLICATE_BATCH_FAILED = '[Lifts] Duplicate Batch by Slot Failure';

export class DuplicateBatchAction implements Action {
    readonly type = DUPLICATE_BATCH;

    constructor(public slotId: number, public batchId: number) {
    }
}

export class DuplicateBatchSuccessAction implements Action {
    readonly type = DUPLICATE_BATCH_SUCCESS;

    constructor(public batch: Batch) {

    }
}

export class DuplicateBatchFailedAction implements Action {
    readonly type = DUPLICATE_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Create batch with tools
export const CREATE_BATCH_WITH_TOOLS = '[Lifts] Create Batch with Tools';
export const CREATE_BATCH_WITH_TOOLS_SUCCESS = '[Lifts] Create Batch with Tools Success';
export const CREATE_BATCH_WITH_TOOLS_FAILED = '[Lifts] Create Batch with Tools Failed';


export class CreateBatchWithToolsAction implements Action {
    readonly type = CREATE_BATCH_WITH_TOOLS;

    constructor(public slotId: number, public tools: any[], public name: string, public withStorage: boolean) {
    }
}

export class CreateBatchWithToolsSuccessAction implements Action {
    readonly type = CREATE_BATCH_WITH_TOOLS_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class CreateBatchWithToolsFailedAction implements Action {
    readonly type = CREATE_BATCH_WITH_TOOLS_FAILED;

    constructor(public payload: any) {
    }
}


// Delete batch
export const DELETE_BATCH = '[Lifts] Delete Batch';
export const DELETE_BATCH_SUCCESS = '[Lifts] Delete Batch Success';
export const DELETE_BATCH_FAILED = '[Lifts] Delete Batch Failed';


export class DeleteBatchAction implements Action {
    readonly type = DELETE_BATCH;

    constructor(public batchId: number) {
    }
}

export class DeleteBatchSuccessAction implements Action {
    readonly type = DELETE_BATCH_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class DeleteBatchFailedAction implements Action {
    readonly type = DELETE_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Add tools to batch
export const ADD_TOOLS_TO_BATCH = '[Lifts] Add Tools to Batch';
export const ADD_TOOLS_TO_BATCH_SUCCESS = '[Lifts] Add Tools to Batch Success';
export const ADD_TOOLS_TO_BATCH_FAILED = '[Lifts] Add Tools to Batch Failed';


export class AddToolsToBatchAction implements Action {
    readonly type = ADD_TOOLS_TO_BATCH;

    constructor(public tools: any[], public batchId: number, public withStorage: boolean) {
    }
}

export class AddToolsToBatchSuccessAction implements Action {
    readonly type = ADD_TOOLS_TO_BATCH_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class AddToolsToBatchFailedAction implements Action {
    readonly type = ADD_TOOLS_TO_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Remove tools from batch
export const REMOVE_TOOLS_FROM_BATCH = '[Lifts] Remove Tools from Batch';
export const REMOVE_TOOLS_FROM_BATCH_SUCCESS = '[Lifts] Remove Tools from Batch Success';
export const REMOVE_TOOLS_FROM_BATCH_FAILED = '[Lifts] Remove Tools from Batch Failed';

export class RemoveToolsFromBatchAction implements Action {
    readonly type = REMOVE_TOOLS_FROM_BATCH;

    constructor(public tools: any[], public batchId: number) {
    }
}

export class RemoveToolsFromBatchSuccessAction implements Action {
    readonly type = REMOVE_TOOLS_FROM_BATCH_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class RemoveToolsFromBatchFailedAction implements Action {
    readonly type = REMOVE_TOOLS_FROM_BATCH_FAILED;

    constructor(public payload: any) {
    }
}

// Update batch
export const UPDATE_BATCH = '[Lifts] Update Batch';
export const UPDATE_BATCH_SUCCESS = '[Lifts] Update Batch Success';
export const UPDATE_BATCH_FAILED = '[Lifts] Update Batch Failed';

export class UpdateBatchAction implements Action {
    readonly type = UPDATE_BATCH;

    constructor(public batch: Batch) {
    }
}

export class UpdateBatchSuccessAction implements Action {
    readonly type = UPDATE_BATCH_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class UpdateBatchFailedAction implements Action {
    readonly type = UPDATE_BATCH_FAILED;

    constructor(public payload: any) {
    }
}


// Update cart for batch tools
export const UPDATE_CART_BATCH_TOOLS = '[Lifts] Update cart for batch tools';
export const UPDATE_CART_BATCH_TOOLS_SUCCESS = '[Lifts] Update cart for batch tools Success';
export const UPDATE_CART_BATCH_TOOLS_FAILED = '[Lifts] Update cart for batch tools Failed';


export class UpdateCartBatchToolsAction implements Action {
    readonly type = UPDATE_CART_BATCH_TOOLS;

    constructor(public tools: any[], public batchId: number, public cart: number) {
    }
}

export class UpdateCartBatchToolsSuccessAction implements Action {
    readonly type = UPDATE_CART_BATCH_TOOLS_SUCCESS;

    constructor(public payload: Batch) {
    }
}

export class UpdateCartBatchToolsActionFailedAction implements Action {
    readonly type = UPDATE_CART_BATCH_TOOLS_FAILED;

    constructor(public payload: any) {
    }
}


export type Action
    = LoadLiftsAction
    | LoadLiftsSuccessAction
    | LoadLiftsFailedAction
    | LoadLiftAction
    | LoadLiftSuccessAction
    | LoadLiftFailedAction
    | LoadPlantsAction
    | LoadPlantsSuccessAction
    | LoadPlantsFailedAction
    | LoadLinesAction
    | LoadLinesSuccessAction
    | LoadLinesFailedAction
    | AddLiftAction
    | AddLiftSuccessAction
    | AddLiftFailedAction
    | RenameLiftAction
    | RenameLiftSuccessAction
    | RenameLiftFailedAction
    | DeleteLiftAction
    | DeleteLiftSuccessAction
    | DeleteLiftFailedAction
    | AddTrayAction
    | AddTraySuccessAction
    | AddTrayFailedAction
    | DeleteTrayAction
    | DeleteTraySuccessAction
    | DeleteTrayFailedAction
    | ToggleTrayStateAction
    | ToggleTrayStateSuccessAction
    | ToggleTrayStateFailedAction
    | LoadTrayDetailsAction
    | LoadTrayDetailsSuccessAction
    | LoadTrayDetailsFailedAction
    | LoadSlotAction
    | LoadSlotSuccessAction
    | LoadSlotFailedAction
    | RenameSlotAction
    | RenameSlotSuccessAction
    | RenameSlotFailedAction
    | AddSlotAction
    | AddSlotSuccessAction
    | AddSlotFailedAction
    | DuplicateSlotAction
    | LoadDuplicatedSlotAction
    | LoadDuplicatedSlotSuccessAction
    | DuplicateSlotFailedAction
    | CopySlotAction
    | LoadCopiedSlotAction
    | LoadCopiedSlotSuccessAction
    | CopySlotSuccessAction
    | CopySlotFailedAction
    | DeleteSlotAction
    | DeleteSlotSuccessAction
    | DeleteSlotFailedAction
    | LoadAllToolsAction
    | LoadAllToolsBySlotAction
    | LoadAllToolsSuccessAction
    | LoadAllToolsFailedAction
    | LoadBatchAction
    | LoadBatchSuccessAction
    | LoadBatchFailedAction
    | CopyBatchAction
    | CopyBatchSuccessAction
    | CopyBatchFailedAction
    | DuplicateBatchAction
    | DuplicateBatchSuccessAction
    | DuplicateBatchFailedAction
    | CreateBatchWithToolsAction
    | CreateBatchWithToolsSuccessAction
    | CreateBatchWithToolsFailedAction
    | DeleteBatchAction
    | DeleteBatchSuccessAction
    | DeleteBatchFailedAction
    | AddToolsToBatchAction
    | AddToolsToBatchSuccessAction
    | AddToolsToBatchFailedAction
    | RemoveToolsFromBatchAction
    | RemoveToolsFromBatchSuccessAction
    | RemoveToolsFromBatchFailedAction
    | UpdateCartBatchToolsAction
    | UpdateCartBatchToolsSuccessAction
    | UpdateCartBatchToolsActionFailedAction
    | UpdateBatchAction
    | UpdateBatchSuccessAction
    | UpdateBatchFailedAction
    | UpdateTrayAction
    | UpdateTraySuccessAction
    | UpdateTrayFailedAction

